<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">{{ $t("compliance-item.name") }} "{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("compliance-item.new") }}</span>
      </h2>

      <table class="table table-bordered table-striped bg-white">
        <thead class="bg-secondary text-white">
          <tr>
            <td class="w-15">{{ $t("compliance.text") }}</td>
            <td class="w-25">{{ $t("compliance-item-group.text") }}</td>
            <td class="w-10">{{ $t("compliance-item.no") }}</td>
            <td class="w-10">{{ $t("compliance-item.level") }}</td>
            <td class="w-20">{{ $t("compliance-item.name") }}</td>
            <td class="w-20">{{ $t("compliance-item.description") }}</td>
            <td class="w-5"></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <select class="form-control " v-model="form.compliance">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option v-for="item in compliances" :key="item" :value="item">{{ item }}</option>
              </select>
            </td>
            <td>
              <filter-select
                key="complianceItemGroupFilter"
                id="complianceItemGroupFilter"
                ref="complianceItemGroupFilter"
                :placeholder="$t('compliance-item-group.text')"
                :selected="form.group"
                @filter="onComplianceItemGroupSearch"
                @changed="onComplianceItemGroupSelect"
              />
            </td>
            <td>
              <sweet-input v-model="form.no" :isValid="true" />
            </td>
            <td>
              <select class="form-control mb-3" v-model="form.level">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
            </td>
            <td>
              <sweet-textarea v-model="form.name" :isValid="true" :rows="5" />
            </td>
            <td>
              <sweet-textarea v-model="form.description" :isValid="true" :rows="5" />
            </td>
            <td>
              <sweet-button
                @click="save()"
                type="submit"
                :loading="isUpdating"
                :disabled="isUpdating || $v.form.$invalid"
                variant="success"
                icon="mdi mdi-check"
                size="sm"
                buttonClass="mt-2"
              >
                {{ $t("common.save") }}
              </sweet-button>
            </td>
          </tr>
        </tbody>
      </table>

      <hr />
    </div>
  </form>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { maxLength, minLength, required } from "vuelidate/lib/validators";

const state = "managementComplianceItem";

export default {
  components: {
    SweetTextarea,
  },
  data() {
    return {
      form: {
        name: undefined,
        description: undefined,
        group: undefined,
        compliance: undefined,
        level: undefined,
        no: undefined,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },

      group: {
        required,
      },
      compliance: {
        required,
      },
      level: {
        required,
      },
      no: {
        required,
      },
    },
  },

  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };

        // this.form = JSON.parse(JSON.stringify(this.prepareFormForEdit(v)));
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/save`, this.form);

        this.form = {};
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", `sidebar-new-compliance-item`);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onComplianceItemGroupSearch(value, callback) {
      const response = await this.$store.dispatch(`managementComplianceItemGroup/paginate`, {
        options: {
          limit: 200,
          sort: { [`name.${this.currentLanguage || tr}`]: "asc" },
        },
        query: {
          "scope.value": { value: "system", isObject: true },
          name: { value },
        },
      });

      callback(response.data?.docs ?? []);
    },
    onComplianceItemGroupSelect(value) {
      this.form.group = value;
    },

    rightPanelClosed() {},
  },
};
</script>
